import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, createElementBlock as _createElementBlock, renderList as _renderList, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Hieronder vindt u, onderverdeeld per fase, een samenvatting van het door u gekozen meer- en minderwerk."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("Standaard opties vindt u niet terug in dit overzicht, enkel het meer- en minderwerk.")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("b", { style: {"font-weight":"600"} }, "Modulaire opties", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { style: {"padding":"16px 0 0 16px","margin-bottom":"8px"} }, "Hieronder vindt u een samenvatting van het door u gekozen meer- en minderwerk voor de modulaire fase.", -1)
const _hoisted_5 = {
  key: 1,
  style: {"font-weight":"600","margin-bottom":"0"}
}
const _hoisted_6 = { class: "no-mb" }
const _hoisted_7 = { style: {"font-size":"12px","font-weight":"400"} }
const _hoisted_8 = {
  key: 1,
  class: "options-mobile",
  style: {"padding":"16px"}
}
const _hoisted_9 = {
  key: 1,
  style: {"padding":"16px","margin-bottom":"0"}
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("b", { style: {"font-weight":"600"} }, "Ruwbouw opties", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { style: {"padding":"16px 0 0 16px","margin-bottom":"8px"} }, "Hieronder vindt u een samenvatting van het door u gekozen meer- en minderwerk voor de ruwbouw fase.", -1)
const _hoisted_12 = {
  key: 1,
  style: {"font-weight":"600","margin-bottom":"0"}
}
const _hoisted_13 = { class: "no-mb" }
const _hoisted_14 = { style: {"font-size":"12px","font-weight":"400"} }
const _hoisted_15 = {
  key: 1,
  class: "options-mobile",
  style: {"padding":"16px"}
}
const _hoisted_16 = {
  key: 1,
  style: {"padding":"16px","margin-bottom":"0"}
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("b", { style: {"font-weight":"600"} }, "Afbouw 1 opties", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", { style: {"padding":"16px 0 0 16px","margin-bottom":"8px"} }, "Hieronder vindt u een samenvatting van het door u gekozen meer- en minderwerk voor de afbouw 1 fase.", -1)
const _hoisted_19 = {
  key: 1,
  style: {"font-weight":"600","margin-bottom":"0"}
}
const _hoisted_20 = { class: "no-mb" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", { style: {"font-size":"12px","font-weight":"400"} }, "incl. 21% BTW", -1)
const _hoisted_22 = {
  key: 1,
  class: "options-mobile",
  style: {"padding":"16px"}
}
const _hoisted_23 = {
  key: 1,
  style: {"padding":"16px","margin-bottom":"0"}
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("b", { style: {"font-weight":"600"} }, "Afbouw 2 opties", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Hieronder vindt u, onderverdeeld per verdieping en ruimte, een samenvatting van het door u gekozen meer- en minderwerk voor de afbouw 2 fase."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Staat een ruimte er niet tussen? Dan is er door u geen meer- en minderwerk gekozen voor de betreffende ruimte. ")
], -1)
const _hoisted_26 = { style: {"font-weight":"600"} }
const _hoisted_27 = { style: {"padding":"16px 0 0 16px","margin-bottom":"8px"} }
const _hoisted_28 = { style: {"font-weight":"600","margin-bottom":"0"} }
const _hoisted_29 = { style: {"font-size":"12px","font-weight":"400"} }
const _hoisted_30 = { class: "no-mb" }
const _hoisted_31 = { style: {"font-size":"12px","font-weight":"400"} }
const _hoisted_32 = {
  key: 1,
  class: "options-mobile",
  style: {"padding":"16px"}
}
const _hoisted_33 = { style: {"font-size":"12px","font-weight":"400"} }
const _hoisted_34 = {
  key: 1,
  style: {"padding":"16px","margin-bottom":"0"}
}
const _hoisted_35 = {
  key: 1,
  style: {"margin-bottom":"0"}
}
const _hoisted_36 = /*#__PURE__*/_createElementVNode("b", { style: {"font-weight":"600"} }, "Afbouw 3 opties", -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("p", { style: {"padding":"16px 0 0 16px","margin-bottom":"8px"} }, "Hieronder vindt u een samenvatting van het door u gekozen meer- en minderwerk voor de afbouw 3 fase.", -1)
const _hoisted_38 = {
  key: 1,
  style: {"font-weight":"600","margin-bottom":"0"}
}
const _hoisted_39 = { class: "no-mb" }
const _hoisted_40 = { style: {"font-size":"12px","font-weight":"400"} }
const _hoisted_41 = {
  key: 1,
  class: "options-mobile",
  style: {"padding":"16px"}
}
const _hoisted_42 = {
  key: 1,
  style: {"padding":"16px","margin-bottom":"0"}
}
const _hoisted_43 = /*#__PURE__*/_createElementVNode("b", { style: {"font-weight":"600"} }, "Extra opties", -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("p", { style: {"padding":"16px 0 0 16px","margin-bottom":"8px"} }, "Hieronder vindt u een samenvatting van het door u gekozen meer- en minderwerk voor de extra fase.", -1)
const _hoisted_45 = {
  key: 1,
  style: {"font-weight":"600","margin-bottom":"0"}
}
const _hoisted_46 = { class: "no-mb" }
const _hoisted_47 = { style: {"font-size":"12px","font-weight":"400"} }
const _hoisted_48 = {
  key: 1,
  class: "options-mobile",
  style: {"padding":"16px"}
}
const _hoisted_49 = {
  key: 1,
  style: {"padding":"16px","margin-bottom":"0"}
}
const _hoisted_50 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_51 = /*#__PURE__*/_createElementVNode("b", null, "Weet u zeker dat u de afbouw opties wilt resetten?", -1)
const _hoisted_52 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Alle afbouw opties zullen worden terug gezet naar de standaard."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("Dit betekend dat al uw gemaakte afbouw keuzes verloren gaan!")
], -1)

import SubtotalWidget from '@/components/SubtotalWidget.vue'
import { useRouter } from 'vue-router'
import { computed, onMounted, ref } from 'vue'
import { headerStore } from '@/stores/header'
import { authStore } from '@/stores/auth'
import { summaryStore } from '@/stores/summary'
import { WarningTwoTone, PrinterOutlined, ReloadOutlined } from '@ant-design/icons-vue'
import { generalStore } from '@/stores/general'
import ListSummaryOption from '@/components/ListSummaryOption.vue'
import axios from 'axios'
import { ls } from '@/ls'
import { notification } from 'ant-design-vue'
import UnityWidget from '@/components/dashboard/UnityWidget.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Summary',
  setup(__props) {

const router = useRouter()

const building = computed(() => ls.get('building'))

const loading = ref(false)
const columns = [
  {
    title: 'Optie',
    key: 'external_ref',
    width: 80
  },
  {
    title: 'Omschrijving',
    key: 'option'
  },
  {
    title: 'Aantal',
    key: 'qty',
    width: 100
  },
  {
    title: 'Prijs incl. BTW',
    key: 'price',
    width: 130
  }
]

onMounted(() => {
  summaryStore().getSummary()
  summaryStore().getPhaseState()
})

function downloadSummaryPdf () : void {
  loading.value = true
  axios.get(process.env.VUE_APP_API_URL + '/summary/pdf', { responseType: 'arraybuffer' })
    .then(response => {
      const blob = new Blob([response.data], { type: 'application/pdf' })
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = 'Samenvatting_B' + ls.get('building').number + '_' + ls.get('building').project.replace(/ /g, '_') + '.pdf'

      link.click()
    }).catch(() => {
      notification.error({
        message: 'Fout tijdens ophalen van de samenvatting!',
        description: 'Er is helaas iets mis gegaan. Probeer het later nog een keer.',
        duration: 0
      })
    }).finally(() => {
      loading.value = false
    })
}

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_collapse_panel = _resolveComponent("a-collapse-panel")!
  const _component_a_collapse = _resolveComponent("a-collapse")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_row, { gutter: [16,4] }, {
    default: _withCtx(() => [
      _createVNode(_component_a_col, {
        xs: {span: 24},
        sm: {span: 24},
        md: {span: 24},
        lg: {span: 18}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_card, {
            title: "Samenvatting",
            loading: _unref(summaryStore)().loading
          }, {
            extra: _withCtx(() => [
              (_unref(building)?.unity_enabled && _unref(building)?.model_available)
                ? (_openBlock(), _createBlock(UnityWidget, {
                    key: 0,
                    style: { marginRight: '8px' }
                  }))
                : _createCommentVNode("", true),
              (_unref(generalStore)().desktop)
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 1,
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push({ name: 'Dashboard' })))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Terug naar dashboard")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            default: _withCtx(() => [
              (['loading', 'demo', 'closed'].includes(_unref(summaryStore)().phaseState) || _unref(authStore)().isDemoCustomer)
                ? (_openBlock(), _createBlock(_component_a_row, { key: 0 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, { span: 24 }, {
                        default: _withCtx(() => [
                          (_unref(summaryStore)().phaseState === 'demo' || _unref(authStore)().isDemoCustomer)
                            ? (_openBlock(), _createBlock(_component_a_alert, {
                                key: 0,
                                type: "info",
                                message: "U bevindt zich in de demo omgeving.",
                                description: "U kunt (nog) geen definitieve bestelling plaatsen voor deze fase.",
                                "show-icon": ""
                              }))
                            : _createCommentVNode("", true),
                          (_unref(summaryStore)().phaseState === 'closed' && _unref(headerStore)().ordersReceived.completion && !_unref(authStore)().isDemoCustomer)
                            ? (_openBlock(), _createBlock(_component_a_alert, {
                                key: 1,
                                type: "success",
                                message: "Bestelling succesvol ontvangen.",
                                "show-icon": ""
                              }, {
                                description: _withCtx(() => [
                                  _createTextVNode(" Wij hebben uw bestelling voor de afbouw opties succesvol ontvangen."),
                                  _hoisted_1,
                                  _createTextVNode(" Het is niet meer mogelijk om uw afbouw opties te wijzigen. Dit is om de voortgang van het bouwproces te continueren. ")
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (_unref(summaryStore)().phaseState === 'closed' && !_unref(headerStore)().ordersReceived.completion && !_unref(authStore)().isDemoCustomer)
                            ? (_openBlock(), _createBlock(_component_a_alert, {
                                key: 2,
                                type: "error",
                                message: "De afbouw fase is gesloten maar wij hebben geen bestelling ontvangen!",
                                "show-icon": ""
                              }, {
                                description: _withCtx(() => [
                                  _createTextVNode(" Neem zo spoedig mogelijk contact op met Hofzicht Makelaars via telefoonnummer 0252 - 530119. ")
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_a_row, { class: "no-mb" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _hoisted_2,
                      _createVNode(_component_a_collapse, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_collapse_panel, {
                            key: "modular",
                            class: "panel-no-padding"
                          }, {
                            header: _withCtx(() => [
                              _hoisted_3
                            ]),
                            default: _withCtx(() => [
                              (_unref(summaryStore)().summary.modular.length)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _hoisted_4,
                                    (_unref(generalStore)().desktop)
                                      ? (_openBlock(), _createBlock(_component_a_table, {
                                          key: 0,
                                          columns: columns,
                                          "data-source": _unref(summaryStore)().summary.modular,
                                          pagination: false
                                        }, {
                                          bodyCell: _withCtx(({ column, record }) => [
                                            (column.key === 'external_ref')
                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                  _createTextVNode(_toDisplayString(record.externalRef), 1)
                                                ], 64))
                                              : _createCommentVNode("", true),
                                            (column.key === 'option')
                                              ? (_openBlock(), _createElementBlock("p", _hoisted_5, [
                                                  _createTextVNode(_toDisplayString(record.name) + " ", 1),
                                                  (record.excluded_from_warranty)
                                                    ? (_openBlock(), _createBlock(_component_a_tooltip, { key: 0 }, {
                                                        title: _withCtx(() => [
                                                          _createTextVNode("Deze optie is uitgesloten van de toepasselijke Woningborg Garantie- en waarborgregeling.")
                                                        ]),
                                                        default: _withCtx(() => [
                                                          _createVNode(_unref(WarningTwoTone), {
                                                            "two-tone-color": "#f38929",
                                                            style: {"margin-left":"4px"}
                                                          })
                                                        ]),
                                                        _: 1
                                                      }))
                                                    : _createCommentVNode("", true)
                                                ]))
                                              : _createCommentVNode("", true),
                                            (column.key === 'qty')
                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                                  _createTextVNode(_toDisplayString(record.qty), 1)
                                                ], 64))
                                              : _createCommentVNode("", true),
                                            (column.key === 'price')
                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                                  _createElementVNode("p", _hoisted_6, "€ " + _toDisplayString(record.price.toLocaleString('nl-NL')), 1),
                                                  _createElementVNode("p", _hoisted_7, "incl. " + _toDisplayString(record.vat_rate) + "% BTW", 1)
                                                ], 64))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _: 1
                                        }, 8, ["data-source"]))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(summaryStore)().summary.modular, (o, index) => {
                                            return (_openBlock(), _createBlock(ListSummaryOption, {
                                              option: o,
                                              "last-item": (index + 1) === _unref(summaryStore)().summary.modular.length,
                                              key: index
                                            }, null, 8, ["option", "last-item"]))
                                          }), 128))
                                        ]))
                                  ], 64))
                                : (_openBlock(), _createElementBlock("p", _hoisted_9, "U heeft (nog) geen meer- en minderwerk gekozen voor de modulaire fase."))
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_collapse_panel, {
                            key: "carcass",
                            class: "panel-no-padding"
                          }, {
                            header: _withCtx(() => [
                              _hoisted_10
                            ]),
                            default: _withCtx(() => [
                              (_unref(summaryStore)().summary.carcass.length)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _hoisted_11,
                                    (_unref(generalStore)().desktop)
                                      ? (_openBlock(), _createBlock(_component_a_table, {
                                          key: 0,
                                          columns: columns,
                                          "data-source": _unref(summaryStore)().summary.carcass,
                                          pagination: false
                                        }, {
                                          bodyCell: _withCtx(({ column, record }) => [
                                            (column.key === 'external_ref')
                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                  _createTextVNode(_toDisplayString(record.externalRef), 1)
                                                ], 64))
                                              : _createCommentVNode("", true),
                                            (column.key === 'option')
                                              ? (_openBlock(), _createElementBlock("p", _hoisted_12, [
                                                  _createTextVNode(_toDisplayString(record.name) + " ", 1),
                                                  (record.excluded_from_warranty)
                                                    ? (_openBlock(), _createBlock(_component_a_tooltip, { key: 0 }, {
                                                        title: _withCtx(() => [
                                                          _createTextVNode("Deze optie is uitgesloten van de toepasselijke Woningborg Garantie- en waarborgregeling.")
                                                        ]),
                                                        default: _withCtx(() => [
                                                          _createVNode(_unref(WarningTwoTone), {
                                                            "two-tone-color": "#f38929",
                                                            style: {"margin-left":"4px"}
                                                          })
                                                        ]),
                                                        _: 1
                                                      }))
                                                    : _createCommentVNode("", true)
                                                ]))
                                              : _createCommentVNode("", true),
                                            (column.key === 'qty')
                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                                  _createTextVNode(_toDisplayString(record.qty), 1)
                                                ], 64))
                                              : _createCommentVNode("", true),
                                            (column.key === 'price')
                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                                  _createElementVNode("p", _hoisted_13, "€ " + _toDisplayString(record.price.toLocaleString('nl-NL')), 1),
                                                  _createElementVNode("p", _hoisted_14, "incl. " + _toDisplayString(record.vat_rate) + "% BTW", 1)
                                                ], 64))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _: 1
                                        }, 8, ["data-source"]))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(summaryStore)().summary.carcass, (o, index) => {
                                            return (_openBlock(), _createBlock(ListSummaryOption, {
                                              option: o,
                                              "last-item": (index + 1) === _unref(summaryStore)().summary.carcass.length,
                                              key: index
                                            }, null, 8, ["option", "last-item"]))
                                          }), 128))
                                        ]))
                                  ], 64))
                                : (_openBlock(), _createElementBlock("p", _hoisted_16, "U heeft (nog) geen meer- en minderwerk gekozen voor de ruwbouw fase."))
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_collapse_panel, {
                            key: "completion1",
                            class: "panel-no-padding"
                          }, {
                            header: _withCtx(() => [
                              _hoisted_17
                            ]),
                            default: _withCtx(() => [
                              (_unref(summaryStore)().summary.completion1.length)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _hoisted_18,
                                    (_unref(generalStore)().desktop)
                                      ? (_openBlock(), _createBlock(_component_a_table, {
                                          key: 0,
                                          columns: columns,
                                          "data-source": _unref(summaryStore)().summary.completion1,
                                          pagination: false
                                        }, {
                                          bodyCell: _withCtx(({ column, record }) => [
                                            (column.key === 'external_ref')
                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                  _createTextVNode(_toDisplayString(record.externalRef), 1)
                                                ], 64))
                                              : _createCommentVNode("", true),
                                            (column.key === 'option')
                                              ? (_openBlock(), _createElementBlock("p", _hoisted_19, [
                                                  _createTextVNode(_toDisplayString(record.name) + " ", 1),
                                                  (record.excluded_from_warranty)
                                                    ? (_openBlock(), _createBlock(_component_a_tooltip, { key: 0 }, {
                                                        title: _withCtx(() => [
                                                          _createTextVNode("Deze indeling is uitgesloten van de toepasselijke Woningborg Garantie- en waarborgregeling.")
                                                        ]),
                                                        default: _withCtx(() => [
                                                          _createVNode(_unref(WarningTwoTone), {
                                                            "two-tone-color": "#f38929",
                                                            style: {"margin-left":"4px"}
                                                          })
                                                        ]),
                                                        _: 1
                                                      }))
                                                    : _createCommentVNode("", true)
                                                ]))
                                              : _createCommentVNode("", true),
                                            (column.key === 'qty')
                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                                  _createTextVNode(_toDisplayString(record.qty), 1)
                                                ], 64))
                                              : _createCommentVNode("", true),
                                            (column.key === 'price')
                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                                  _createElementVNode("p", _hoisted_20, "€ " + _toDisplayString(record.price.toLocaleString('nl-NL')), 1),
                                                  _hoisted_21
                                                ], 64))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _: 1
                                        }, 8, ["data-source"]))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(summaryStore)().summary.completion1, (o, index) => {
                                            return (_openBlock(), _createBlock(ListSummaryOption, {
                                              option: o,
                                              "last-item": (index + 1) === _unref(summaryStore)().summary.completion1.length,
                                              key: index
                                            }, null, 8, ["option", "last-item"]))
                                          }), 128))
                                        ]))
                                  ], 64))
                                : (_openBlock(), _createElementBlock("p", _hoisted_23, "U heeft (nog) geen meer- en minderwerk gekozen voor de afbouw 1 fase."))
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_collapse_panel, { key: "completion2" }, {
                            header: _withCtx(() => [
                              _hoisted_24
                            ]),
                            default: _withCtx(() => [
                              (Object.keys(_unref(summaryStore)().summary.completion2.levels).length)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _hoisted_25,
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(summaryStore)().summary.completion2.levels, (level) => {
                                      return (_openBlock(), _createElementBlock(_Fragment, {
                                        key: level.id
                                      }, [
                                        _createElementVNode("h4", null, _toDisplayString(level.name), 1),
                                        (level.rooms.length)
                                          ? (_openBlock(), _createBlock(_component_a_collapse, {
                                              key: 0,
                                              style: {"margin-bottom":"16px"}
                                            }, {
                                              default: _withCtx(() => [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(level.rooms, (room) => {
                                                  return (_openBlock(), _createElementBlock(_Fragment, {
                                                    key: room.id
                                                  }, [
                                                    (room.options.length)
                                                      ? (_openBlock(), _createBlock(_component_a_collapse_panel, {
                                                          class: "panel-no-padding",
                                                          key: room.id
                                                        }, {
                                                          header: _withCtx(() => [
                                                            _createElementVNode("b", _hoisted_26, _toDisplayString(room.level) + "." + _toDisplayString(room.position) + " - " + _toDisplayString(room.name), 1)
                                                          ]),
                                                          extra: _withCtx(() => [
                                                            _createTextVNode("€" + _toDisplayString(room.optionTotal), 1)
                                                          ]),
                                                          default: _withCtx(() => [
                                                            (room.options.length)
                                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                                  _createElementVNode("p", _hoisted_27, "Hieronder vindt u een samenvatting van het door u gekozen meer- en minderwerk voor " + _toDisplayString(room.level) + "." + _toDisplayString(room.position) + " " + _toDisplayString(room.name) + ".", 1),
                                                                  (_unref(generalStore)().desktop)
                                                                    ? (_openBlock(), _createBlock(_component_a_table, {
                                                                        key: 0,
                                                                        columns: columns,
                                                                        "data-source": room.options,
                                                                        pagination: false
                                                                      }, {
                                                                        bodyCell: _withCtx(({ column, record }) => [
                                                                          (column.key === 'external_ref')
                                                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                                                _createTextVNode(_toDisplayString(record.externalRef), 1)
                                                                              ], 64))
                                                                            : _createCommentVNode("", true),
                                                                          (column.key === 'option')
                                                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                                                _createElementVNode("p", _hoisted_28, [
                                                                                  _createTextVNode(_toDisplayString(record.name) + " ", 1),
                                                                                  (record.excluded_from_warranty)
                                                                                    ? (_openBlock(), _createBlock(_component_a_tooltip, { key: 0 }, {
                                                                                        title: _withCtx(() => [
                                                                                          _createTextVNode("Deze optie is uitgesloten van de toepasselijke Woningborg Garantie- en waarborgregeling.")
                                                                                        ]),
                                                                                        default: _withCtx(() => [
                                                                                          _createVNode(_unref(WarningTwoTone), {
                                                                                            "two-tone-color": "#f38929",
                                                                                            style: {"margin-left":"4px"}
                                                                                          })
                                                                                        ]),
                                                                                        _: 1
                                                                                      }))
                                                                                    : _createCommentVNode("", true)
                                                                                ]),
                                                                                _createElementVNode("p", _hoisted_29, [
                                                                                  _createTextVNode(_toDisplayString(record.elementNameSales), 1),
                                                                                  ([30, 70].includes(record.elementGroup.number))
                                                                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                                                        _createTextVNode(" op positie " + _toDisplayString(record.elementPosition), 1)
                                                                                      ], 64))
                                                                                    : _createCommentVNode("", true),
                                                                                  _createTextVNode(" - " + _toDisplayString(record.subElementName), 1)
                                                                                ])
                                                                              ], 64))
                                                                            : _createCommentVNode("", true),
                                                                          (column.key === 'qty')
                                                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                                                                _createTextVNode(_toDisplayString(record.qty), 1)
                                                                              ], 64))
                                                                            : _createCommentVNode("", true),
                                                                          (column.key === 'price')
                                                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                                                                _createElementVNode("p", _hoisted_30, "€ " + _toDisplayString(record.price.toLocaleString('nl-NL')), 1),
                                                                                _createElementVNode("p", _hoisted_31, "incl. " + _toDisplayString(record.vat_rate) + "% BTW", 1)
                                                                              ], 64))
                                                                            : _createCommentVNode("", true)
                                                                        ]),
                                                                        _: 2
                                                                      }, 1032, ["data-source"]))
                                                                    : (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(room.options, (o, index) => {
                                                                          return (_openBlock(), _createBlock(ListSummaryOption, {
                                                                            option: o,
                                                                            "last-item": (index + 1) === room.options.length,
                                                                            key: index
                                                                          }, {
                                                                            subtitle: _withCtx(() => [
                                                                              _createElementVNode("p", _hoisted_33, [
                                                                                _createTextVNode(_toDisplayString(o.elementNameSales), 1),
                                                                                ([30, 70].includes(o.elementGroup.number))
                                                                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                                                      _createTextVNode(" op positie " + _toDisplayString(o.elementPosition), 1)
                                                                                    ], 64))
                                                                                  : _createCommentVNode("", true),
                                                                                _createTextVNode(" - " + _toDisplayString(o.subElementName), 1)
                                                                              ])
                                                                            ]),
                                                                            _: 2
                                                                          }, 1032, ["option", "last-item"]))
                                                                        }), 128))
                                                                      ]))
                                                                ], 64))
                                                              : (_openBlock(), _createElementBlock("p", _hoisted_34, "U heeft (nog) geen meer- en minderwerk gekozen voor deze ruimte in de afbouw 2 fase."))
                                                          ]),
                                                          _: 2
                                                        }, 1024))
                                                      : _createCommentVNode("", true)
                                                  ], 64))
                                                }), 128))
                                              ]),
                                              _: 2
                                            }, 1024))
                                          : _createCommentVNode("", true)
                                      ], 64))
                                    }), 128))
                                  ], 64))
                                : (_openBlock(), _createElementBlock("p", _hoisted_35, "U heeft (nog) geen meer- en minderwerk gekozen voor de afbouw 2 fase."))
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_collapse_panel, {
                            key: "completion3",
                            class: "panel-no-padding"
                          }, {
                            header: _withCtx(() => [
                              _hoisted_36
                            ]),
                            default: _withCtx(() => [
                              (_unref(summaryStore)().summary.completion3.length)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _hoisted_37,
                                    (_unref(generalStore)().desktop)
                                      ? (_openBlock(), _createBlock(_component_a_table, {
                                          key: 0,
                                          columns: columns,
                                          "data-source": _unref(summaryStore)().summary.completion3,
                                          pagination: false
                                        }, {
                                          bodyCell: _withCtx(({ column, record }) => [
                                            (column.key === 'external_ref')
                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                  _createTextVNode(_toDisplayString(record.externalRef), 1)
                                                ], 64))
                                              : _createCommentVNode("", true),
                                            (column.key === 'option')
                                              ? (_openBlock(), _createElementBlock("p", _hoisted_38, [
                                                  _createTextVNode(_toDisplayString(record.name) + " ", 1),
                                                  (record.excluded_from_warranty)
                                                    ? (_openBlock(), _createBlock(_component_a_tooltip, { key: 0 }, {
                                                        title: _withCtx(() => [
                                                          _createTextVNode("Deze optie is uitgesloten van de toepasselijke Woningborg Garantie- en waarborgregeling.")
                                                        ]),
                                                        default: _withCtx(() => [
                                                          _createVNode(_unref(WarningTwoTone), {
                                                            "two-tone-color": "#f38929",
                                                            style: {"margin-left":"4px"}
                                                          })
                                                        ]),
                                                        _: 1
                                                      }))
                                                    : _createCommentVNode("", true)
                                                ]))
                                              : _createCommentVNode("", true),
                                            (column.key === 'qty')
                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                                  _createTextVNode(_toDisplayString(record.qty), 1)
                                                ], 64))
                                              : _createCommentVNode("", true),
                                            (column.key === 'price')
                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                                  _createElementVNode("p", _hoisted_39, "€ " + _toDisplayString(record.price.toLocaleString('nl-NL')), 1),
                                                  _createElementVNode("p", _hoisted_40, "incl. " + _toDisplayString(record.vat_rate) + "% BTW", 1)
                                                ], 64))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _: 1
                                        }, 8, ["data-source"]))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(summaryStore)().summary.completion3, (o, index) => {
                                            return (_openBlock(), _createBlock(ListSummaryOption, {
                                              option: o,
                                              "last-item": (index + 1) === _unref(summaryStore)().summary.completion3.length,
                                              key: index
                                            }, null, 8, ["option", "last-item"]))
                                          }), 128))
                                        ]))
                                  ], 64))
                                : (_openBlock(), _createElementBlock("p", _hoisted_42, "U heeft (nog) geen meer- en minderwerk gekozen voor de afbouw 3 fase."))
                            ]),
                            _: 1
                          }),
                          (_unref(headerStore)().extraPhaseEnabled)
                            ? (_openBlock(), _createBlock(_component_a_collapse_panel, {
                                key: "extra",
                                class: "panel-no-padding"
                              }, {
                                header: _withCtx(() => [
                                  _hoisted_43
                                ]),
                                default: _withCtx(() => [
                                  (_unref(summaryStore)().summary.extra.length)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _hoisted_44,
                                        (_unref(generalStore)().desktop)
                                          ? (_openBlock(), _createBlock(_component_a_table, {
                                              key: 0,
                                              columns: columns,
                                              "data-source": _unref(summaryStore)().summary.extra,
                                              pagination: false
                                            }, {
                                              bodyCell: _withCtx(({ column, record }) => [
                                                (column.key === 'external_ref')
                                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                      _createTextVNode(_toDisplayString(record.externalRef), 1)
                                                    ], 64))
                                                  : _createCommentVNode("", true),
                                                (column.key === 'option')
                                                  ? (_openBlock(), _createElementBlock("p", _hoisted_45, _toDisplayString(record.name), 1))
                                                  : _createCommentVNode("", true),
                                                (column.key === 'qty')
                                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                                      _createTextVNode(_toDisplayString(record.qty), 1)
                                                    ], 64))
                                                  : _createCommentVNode("", true),
                                                (column.key === 'price')
                                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                                      _createElementVNode("p", _hoisted_46, "€ " + _toDisplayString(record.price.toLocaleString('nl-NL')), 1),
                                                      _createElementVNode("p", _hoisted_47, "incl. " + _toDisplayString(record.vat_rate) + "% BTW", 1)
                                                    ], 64))
                                                  : _createCommentVNode("", true)
                                              ]),
                                              _: 1
                                            }, 8, ["data-source"]))
                                          : (_openBlock(), _createElementBlock("div", _hoisted_48, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(summaryStore)().summary.extra, (o, index) => {
                                                return (_openBlock(), _createBlock(ListSummaryOption, {
                                                  option: o,
                                                  "last-item": (index + 1) === _unref(summaryStore)().summary.extra.length,
                                                  key: index
                                                }, null, 8, ["option", "last-item"]))
                                              }), 128))
                                            ]))
                                      ], 64))
                                    : (_openBlock(), _createElementBlock("p", _hoisted_49, "U heeft (nog) geen meer- en minderwerk gekozen voor de extra fase."))
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  (_unref(summaryStore)().phaseState === 'open' && !_unref(authStore)().isDemoCustomer)
                    ? (_openBlock(), _createBlock(_component_a_col, {
                        key: 0,
                        span: 24
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_divider),
                          _createVNode(_component_a_row, { style: {"margin-bottom":"0"} }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_col, { span: 24 }, {
                                default: _withCtx(() => [
                                  _createElementVNode("p", {
                                    style: _normalizeStyle(_unref(generalStore)().desktop ? { margin: '0 0 0 24px' } : { margin: '0' })
                                  }, [
                                    _createTextVNode("De extra opties zijn een aanvulling op de tussen de ondernemer en verkrijger gesloten (koop-) aannemingsovereenkomst."),
                                    _hoisted_50,
                                    _createTextVNode("De Woningborg Garantie- en waarborgregeling is tevens van toepassing op de gekozen extra opties.")
                                  ], 4)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_divider),
                          (_unref(summaryStore)().summary.excluded_from_warranty_options)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createVNode(_component_a_row, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_col, { span: 24 }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_checkbox, {
                                          checked: _unref(summaryStore)().agree.warranty,
                                          onChange: _cache[1] || (_cache[1] = ($event: any) => (_unref(summaryStore)().agree.warranty = !_unref(summaryStore)().agree.warranty))
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode("Ik/wij ga(an) ermee akkoord dat de keuze van gemarkeerde ("),
                                            _createVNode(_unref(WarningTwoTone), { "two-tone-color": "#f38929" }),
                                            _createTextVNode(") opties tot gevolg heeft dat het betreffende onderdeel is uitgesloten van de toepasselijke Woningborg Garantie- en waarborgregeling en dat de ondernemer niet aansprakelijk gesteld kan worden voor gebreken en/of schaden en/of gevolgschaden ten gevolge van het niet leveren en/of aanbrengen van betreffende materialen en constructies. Voor de gemarkeerde opties waarbij dit tekstueel is aangegeven, geldt dat bij oplevering niet voldaan wordt aan de wettelijke voorschriften (met name het Bouwbesluit).")
                                          ]),
                                          _: 1
                                        }, 8, ["checked"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_row, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_col, { span: 24 }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_checkbox, {
                                          checked: _unref(summaryStore)().agree.responsibility,
                                          onChange: _cache[2] || (_cache[2] = ($event: any) => (_unref(summaryStore)().agree.responsibility = !_unref(summaryStore)().agree.responsibility))
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode("Ik/wij aanvaard(en) de verantwoordelijkheid om de woning c.q. het privé-gedeelte na oplevering op de niet uit te voeren onderdelen aan de wettelijke voorschriften te laten voldoen. Deze verantwoordelijkheid verschuift van de ondernemer naar mij/ons als koper.")
                                          ]),
                                          _: 1
                                        }, 8, ["checked"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_row, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_col, { span: 24 }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_checkbox, {
                                          checked: _unref(summaryStore)().agree.activities,
                                          onChange: _cache[3] || (_cache[3] = ($event: any) => (_unref(summaryStore)().agree.activities = !_unref(summaryStore)().agree.activities))
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode("Ik/wij verklaren, dat de ondernemer opdracht krijgt om de woning zonder de vermelde werkzaamheden en/of materialen uit te voeren en/of te leveren.")
                                          ]),
                                          _: 1
                                        }, 8, ["checked"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ], 64))
                            : _createCommentVNode("", true),
                          _createVNode(_component_a_row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_col, { span: 24 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_checkbox, {
                                    checked: _unref(summaryStore)().agree.terms,
                                    onChange: _cache[4] || (_cache[4] = ($event: any) => (_unref(summaryStore)().agree.terms = !_unref(summaryStore)().agree.terms))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Ik/wij ga(an) ermee akkoord dat met het versturen van de opties opdracht gegeven wordt tot de uitvoering van meer- (en minder)werk en dat na de sluitingsdatum deze opties niet meer gewijzigd kunnen worden.")
                                    ]),
                                    _: 1
                                  }, 8, ["checked"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_divider),
                          _createVNode(_component_a_row, { class: "no-mb" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_col, { span: 24 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_button, {
                                    style: {"margin-left":"8px"},
                                    loading: loading.value,
                                    disabled: _unref(authStore)().restricted() || loading.value,
                                    onClick: downloadSummaryPdf
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(PrinterOutlined)),
                                      _createTextVNode(" Samenvatting printen")
                                    ]),
                                    _: 1
                                  }, 8, ["loading", "disabled"]),
                                  (!_unref(headerStore)().ordersReceived.completion)
                                    ? (_openBlock(), _createBlock(_component_a_popconfirm, {
                                        key: 0,
                                        disabled: _unref(authStore)().restricted(),
                                        placement: "topLeft",
                                        "ok-text": "Ja",
                                        "cancel-text": "Nee",
                                        onConfirm: _unref(summaryStore)().resetCompletion
                                      }, {
                                        title: _withCtx(() => [
                                          _hoisted_51,
                                          _hoisted_52
                                        ]),
                                        default: _withCtx(() => [
                                          _createVNode(_component_a_button, {
                                            style: _normalizeStyle([{"margin-left":"8px"}, _unref(generalStore)().desktop ? {} : { width: '100%', marginBottom: '8px' }]),
                                            loading: _unref(summaryStore)().resettingCompletion
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_unref(ReloadOutlined)),
                                              _createTextVNode(" Afbouw opties resetten")
                                            ]),
                                            _: 1
                                          }, 8, ["loading", "style"])
                                        ]),
                                        _: 1
                                      }, 8, ["disabled", "onConfirm"]))
                                    : _createCommentVNode("", true),
                                  _createVNode(_component_a_button, {
                                    type: "primary",
                                    loading: _unref(summaryStore)().creatingOrder,
                                    disabled: _unref(authStore)().restricted() || _unref(summaryStore)().summary.excluded_from_warranty_options ? (!_unref(summaryStore)().agree.warranty || !_unref(summaryStore)().agree.responsibility || !_unref(summaryStore)().agree.activities || !_unref(summaryStore)().agree.terms) : !_unref(summaryStore)().agree.terms,
                                    style: _normalizeStyle(_unref(generalStore)().desktop ? { float: 'right' } : { width: '100%' }),
                                    onClick: _unref(summaryStore)().createOrder
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Afbouw - Bestelling plaatsen")
                                    ]),
                                    _: 1
                                  }, 8, ["loading", "disabled", "style", "onClick"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["loading"])
        ]),
        _: 1
      }),
      _createVNode(_component_a_col, {
        span: _unref(generalStore)().desktop ? 6 : 24
      }, {
        default: _withCtx(() => [
          _createVNode(SubtotalWidget)
        ]),
        _: 1
      }, 8, ["span"])
    ]),
    _: 1
  }))
}
}

})